import Vue from 'vue'
import VueRouter from 'vue-router'
import Routes from './routes'
import 'bulma/css/bulma.css'
import 'vue-material-design-icons/styles.css'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueRouter)
const router = new VueRouter({
  mode: "history",
  routes: Routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
        return savedPosition;
    } else {
        return { x: 0, y: 0 }
    }
  }  
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
